import React from 'react';
import { CAPACITY_MARKETS, fmtCapacityMw, sumMemberCapacities } from '../lib/prequalifiedCapacity';
import { Field, Panel } from './primitives';

/**
 * The battery's registered (prequalified) capacity per market: the sum of its member
 * devices' registered capacities. An unregistered market shows honestly as "Not registered"
 * rather than being hidden — a battery trading a direction nothing is registered for is
 * exactly the state worth seeing. The whole panel renders nothing when the gateway predates
 * the field, where "Not registered" would be a false claim about every market.
 */
const PrequalifiedCapacity = ({ battery }) => {
    const capacities = sumMemberCapacities(battery.members);
    if (capacities === null) {
        return null;
    }
    return (
        <Panel
            icon="fa-certificate"
            title="Prequalified capacity"
            info="Registered capacity per market: the sum of the member devices' capacities as registered after prequalification. These are entered records, not measurements. 'Not registered' means no capacity is registered for that market."
        >
            <div className="gw-card__grid vb-grid--4">
                {CAPACITY_MARKETS.map(market => (
                    <Field
                        key={market.key}
                        label={market.label}
                        node={
                            <span className="vb-product" style={capacities[market.key] > 0 ? { color: market.color } : undefined}>
                                {fmtCapacityMw(capacities[market.key])}
                            </span>
                        }
                    />
                ))}
            </div>
            <p className="gw-card__foot">
                Summed over {battery.members.length === 1 ? 'the 1 member device' : `the ${battery.members.length} member devices`}.
            </p>
        </Panel>
    );
};

export default PrequalifiedCapacity;
